import React from 'react';
import logo from '../assets/images/logo.png'; 

const Header = ({ currentView, onViewChange }) => {
  return (
    <div className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            {/* Use the imported logo */}
            <img src={logo} alt="Logo" className="h-8 w-auto" />
          </div>
          <div className="flex space-x-4">
            <button
              onClick={() => onViewChange('deck')}
              className={`px-4 py-2 rounded-lg ${
                currentView === 'deck' 
                  ? 'bg-blue-600 text-white' 
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              Presentation
            </button>
            <button
              onClick={() => onViewChange('quote')}
              className={`px-4 py-2 rounded-lg ${
                currentView === 'quote' 
                  ? 'bg-blue-600 text-white' 
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              Quote Builder
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
